import React, { useEffect, useState, Fragment, useContext } from "react";
import Layout from "components/sales/layoutChange/layout";
import { Button } from "react-bootstrap";
import ConstantInput from "components/sales/Input/constantInput/constantInput";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ModalPop from "components/sales/modal/modal";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";

const EditLob = ({ getLobListing, editLob, history, lobList = []}) => {
  const { baseUrl } = useContext(BaseUrl);
  const { id } = useParams();
  const [name, setName] = useState("");
  const [dimensionValueType, setDimensionValueType] = useState(null);
  const [totalingFrom, setTotalingFrom] = useState(null);
  const [totalingTo, setTotalingTo] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [showTotaling, setShowTotaling] = useState(false);
  const [lobCode, setLobCode] = useState(null);

  const dimensionValueTypeOptions = [
    { id: "Begin-Total", name: "Begin-Total" },
    { id: "Standard", name: "Standard" },
    { id: "End-Total", name: "End-Total" },
  ];

  useEffect(() => {
    if (dimensionValueType?.id === "End-Total") {
      setShowTotaling(true);
    } else {
      setShowTotaling(false);
      setTotalingFrom(null);
      setTotalingTo(null);
    }
  }, [dimensionValueType]);

  useEffect(() => {
    const fetchLobDetails = async () => {
        if (!id) return;

        setIsLoading(true);
        try {
            await getLobListing(null, null, id);
            setIsLoading(false);
        } catch (err) {
            console.error("Error fetching LOB:", err);
            toast.error("Failed to fetch LOB details");
            setIsLoading(false);
        }
    };

    fetchLobDetails();
    }, [id, getLobListing]);

    useEffect(() => {
      
      if (!lobList?.resultSets?.length) return;

      const lobData = lobList.resultSets[0];
      
      if (lobData) {
          setName(lobData.name || "");
          setDimensionValueType(dimensionValueTypeOptions.find(opt => opt.id == lobData.dimension_value_type) || null);
          setTotalingFrom(lobData.totaling_from || "");
          setTotalingTo(lobData.totaling_to || "");
          setLobCode(lobData.erp_code || "");
          setIsLoading(false);
      }

    }, [lobList, id]);

  const handleSubmit = async () => {

    if (!name || !dimensionValueType) {
      toast.error("Please fill all mandatory fields");
      return;
    }

    if (dimensionValueType?.id === "End-Total") {
      if (!totalingFrom || !totalingTo) {
        toast.error("Please fill totaling range for End-Total");
        return;
      }

      const from = parseInt(totalingFrom);
      const to = parseInt(totalingTo);

      if (from === to) {
        toast.error("Totaling from and to cannot be same");
        return;
      }

      if (from > to) {
        toast.error("Totaling from cannot be greater than totaling to");
        return;
      }
    }

    setIsLoading(true);

    const data = {
      id,
      name,
      dimension_value_type: dimensionValueType.id,
      totaling_from: totalingFrom,
      totaling_to: totalingTo,
      lob_code: lobCode
    };

    try {
      const res = await editLob(data);

      if (res?.data?.status_code === 200 || res?.data?.status === true) {
        setIsModal(true);
        setName("");
        setTotalingFrom(null);
        setTotalingTo(null);
        setDimensionValueType(null);
      } else {
        toast.error(res?.data?.message || "Failed to update LOB");
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const handleModalHide = () => {
    setIsModal(false);
    history.push(`${baseUrl}/lob-list`);
  };

  return (
    <Layout title="Back to LOB List" isLoading={isLoading} isGoback={true}>
      <Fragment>
        <div className="card">
          <div className="card-header">Edit LOB</div>
          <div className="card-body">
            <div className="row">
              {/* Name */}
              <div className="col-md-4">
                <ConstantInput
                  label="Name"
                  type="text"
                  value={name}
                  handleChange={(val) => setName(val)}
                  required
                  isStarRequired={true}
                />
              </div>

              {/* Dimension Value Type */}
              <div className="col-md-4">
                <DropDownInput
                  label="Dimension Value Type"
                  data={dimensionValueTypeOptions}
                  getValueById={dimensionValueType?.id}
                  getIdValue={(val) => setDimensionValueType(val)}
                  required
                  isStarRequired={true}
                />
              </div>

              <div className="col-md-4">
                <ConstantInput
                  label="LOB Code"
                  type="number"
                  value={lobCode}
                  handleChange={(val) => setLobCode(val)}
                  required
                  isStarRequired={true}
                  disabled
                />
              </div>

              {showTotaling &&
                <>
                  <div className="col-md-4">
                    <ConstantInput
                      label="Totaling From"
                      type="number"
                      value={totalingFrom}
                      handleChange={(val) => setTotalingFrom(val)}
                      required
                      isStarRequired={true}
                    />
                  </div>

                  <div className="col-md-4">
                    <ConstantInput
                      label="Totaling To"
                      type="number"
                      value={totalingTo}
                      handleChange={(val) => setTotalingTo(val)}
                      required
                      isStarRequired={true}
                    />
                  </div>
                </>
              }

              {/* Submit Button */}
              <div className="col-md-12 mt-3">
                <Button onClick={handleSubmit}>Submit</Button>
              </div>
            </div>
          </div>
        </div>

        {/* Success Modal */}
        <ModalPop
          title="Success"
          show={isModal}
          handleModalHide={handleModalHide}
          keyboard
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt="success" />
            </div>
            <h5>LOB Updated Successfully!</h5>
          </div>
        </ModalPop>
      </Fragment>
    </Layout>
  );
};

export default EditLob;